import { PageantRegistration } from "API/Generated/PageantRegistration";
import { ReceivedScores } from "API/Generated/ReceivedScores";
import { RegisteredContestantAwardRelationship } from "API/Generated/RegisteredContestantAwardRelationship";
import { BasicContestantInfoDTO, BasicRegisteredContestantSelectionsDTO, BulkContestantSelectionUpdateRequestDTO, CompletePageantRegistrationDTO, PageantAgeGroupBaseModel, PageantRegistrationRequest, PictureModel, ReceivedScore, ReceivedScoreBaseModel, RegisteredPageantContestantBaseModel, RegisteredPageantContestantModel } from "API/Generated/data-contracts";
import { makeObservable, observable, action } from "mobx";


class PageantRegistrationStore {
    PageantRegistration: PageantRegistration = new PageantRegistration();
    CurrentPageantRegistration: RegisteredPageantContestantModel;
    ShowRegistrationForm: boolean = false;
    AllowEdit: boolean = false;
    AgeGroups: PageantAgeGroupBaseModel[] = [];
    SupremeGroups: PageantAgeGroupBaseModel[] = [];
    RegisteredContestantAwardRelationships: RegisteredContestantAwardRelationship[] = [];
    ReceivedScore: ReceivedScoreBaseModel[] = [];
    ReceivedScoreService: ReceivedScores = new ReceivedScores();
    AllReceivedScores: Record<number, ReceivedScoreBaseModel[]> = {}

    // ✅ NEW OBSERVABLES
    AllPageantRegistrations: RegisteredPageantContestantBaseModel[] = [];
    BasicContestantInfoList: BasicContestantInfoDTO[] = [];
    ContestantSelections: BasicRegisteredContestantSelectionsDTO | null = null;
    AllContestantSelections: BasicRegisteredContestantSelectionsDTO[] = [];




    constructor(currentPageantRegistration: RegisteredPageantContestantModel, showRegistrationForm: boolean) {
        makeObservable(this, {
            CurrentPageantRegistration: observable,
            ShowRegistrationForm: observable,
            AllowEdit: observable,
            AgeGroups: observable,
            setAgeGroups: action,
            SupremeGroups: observable,
            setSupremeGroups: action,
            setAllowEdit: action,
            RegisteredContestantAwardRelationships: observable,
            saveScores: action,
            loadScores: action,
            getTotalScoresWithDropsForContestantAsyncAll: action, // Add this line

            AllReceivedScores: observable, // ✅ Make reactive
           // fetchAllScoresForPageant: action, // ✅ Add the new method

            // ✅ Make new observables reactive
            AllPageantRegistrations: observable,
            BasicContestantInfoList: observable,
            ContestantSelections: observable,
            AllContestantSelections: observable,


        })
        // makePersistable(this, { name: 'PageantRegistration', properties: ['CurrentPageantRegistration', 'ShowRegistrationForm', 'AllowEdit', 'AgeGroups', 'SupremeGroups']})

        this.CurrentPageantRegistration = currentPageantRegistration;
    }


    setAgeGroups(ageGroups: PageantAgeGroupBaseModel[]) {
        this.AgeGroups = ageGroups;
    }

    setSupremeGroups(supremeGroups: PageantAgeGroupBaseModel[]) {
        this.SupremeGroups = supremeGroups;
    }

    // Fetch contestant's age group
    async getAgeGroup(pageantId: number, birthday: Date, takenFallback: boolean, moveUpAgeGroup: boolean) {
        try {
            // Convert the Date to ISO string
            const birthdayString = birthday.toISOString();  // Convert Date to string (ISO format)

            // Ensure the function properly waits for the response using await
            const response = await this.PageantRegistration.getAgeRange({
                pageantId,
                birthday: birthdayString,  // Send the birthday as a string
                takenFallback,
                moveUpAgeGroup,
            });

            return response && response.data ? response.data : null;
        } catch (error) {
            // Handle errors properly
            console.error("Error fetching age group:", error);
            return null;  // Return null on error
        }
    }

    // Fetch contestant's supreme groups
async getSupremeGroups(
  pageantId: number,
  birthday: Date,
  takenFallback: boolean,
  moveUpAgeGroup: boolean,
  divisionId?: number | null
) {
  try {
    const birthdayString = birthday.toISOString();

    const response = await this.PageantRegistration.getSupremeGroups({
      pageantId,
      birthday: birthdayString,
      takenFallback,
      moveUpAgeGroup,
      divisionId: divisionId ?? undefined, // ✅ convert null → undefined
    });

    return response?.data ?? null;
  } catch (error) {
    console.error("Error fetching supreme groups:", error);
    return null;
  }
}



    // ✅ Fetch all registrations for a pageant
    async fetchAllRegistrationsForPageant(pageantId: number): Promise<RegisteredPageantContestantBaseModel[]> {
        try {
            console.log(`Fetching all registrations for Pageant ID: ${pageantId}`);
            //const response = await this.PageantRegistration.getAllRegistrationsForPageant(pageantId);
            const response = await this.PageantRegistration.getAllRegistrationsByPageantId(pageantId);
          
            console.log("API Response:", response);

            if (response?.data?.data && Array.isArray(response.data.data)) {
                this.AllPageantRegistrations = response.data.data;  // ✅ Store in MobX store
                return response.data.data;  // ✅ Return the fetched data
            } else {
                console.warn(`No valid contestant data found for pageant ${pageantId}`);
                this.AllPageantRegistrations = [];
                return [];  // ✅ Return empty array to avoid undefined
            }
        } catch (error) {
            console.error("Error fetching contestants in a pageant:", error);
            return [];  // ✅ Return empty array on error
        }
    }
    


  
    


    async fetchRegistrationsForIndividualContestant(registeredContestantId: number): Promise<CompletePageantRegistrationDTO | null> {
        try {
            console.log(`Fetching individual registration for registeredContestantId ID: ${registeredContestantId}`);
            const response = await this.PageantRegistration.getCompleteRegistrationForContestant(registeredContestantId);
            console.log("API Response:", response);
    
            // Check if the response contains the expected data
            if (response?.data?.data) {
                const registrationData = response.data.data;  // This should be the complete registration object
    
                // Store the data in MobX store
                this.AllPageantRegistrations = [registrationData];  // If you want to store as an array of registrations
    
                return registrationData;  // Return the fetched registration data
            } else {
                console.warn(`No valid contestant data found for registered contestant ${registeredContestantId}`);
                this.AllPageantRegistrations = [];  // Reset the registrations list
                return null;  // Return null to indicate no data found
            }
        } catch (error) {
            console.error("Error fetching contestant in a pageant:", error);
            this.AllPageantRegistrations = [];  // Reset the registrations list on error
            return null;  // Return null on error
        }
    }



    async updateContestantAgeGroup(pageantRegistrationId: number) {
        try {
            const response = await this.PageantRegistration.getAgeRangeAndSupremeGroups({
                pageantRegistrationId,
            });

            if (response.ok && response.data) {
                const { ageGroup, supremeGroups } = response.data as any;

                // ✅ Correct way to find the local contestant by ID
                const contestant = this.CurrentPageantRegistration;

                if (contestant) {
                    // ✅ Update age group and supreme groups locally
                    contestant.ageGroupId = ageGroup?.id ?? null;
                    contestant.supremeGroups = (supremeGroups || []).map((group) => group.id);

                    console.log(`✅ Updated contestant ${contestant.contestantUser?.firstName || ''} (ID: ${contestant.id})`);
                } else {
                    console.warn(`⚠️ No local contestant found for ID ${pageantRegistrationId}`);
                }

                return response.data;
            } else {
                alert("Failed to update registration!");
                return null;
            }
        } catch (error) {
            console.error("❌ Error updating age group:", error);
            alert("An error occurred while updating the registration.");
            return null;
        }
    }


    async calculateAndAssignAgeAndSupremeGroups(pageantRegistrationId: number) {
        try {
          const response = await this.PageantRegistration.calculateAndAssignAgeAndSuprmeGroups({
            pageantRegistrationId,
          });
      
          if (response.ok && response.data) {
            const {
              ageGroupId,
              supremeGroupIds,
            } = response.data as {
              ageGroupId: number;
              supremeGroupIds: number[];
            };
      
            const contestant = this.CurrentPageantRegistration;
      
            if (contestant) {
              contestant.ageGroupId = ageGroupId ?? null;
      
              const allGroups = this.SupremeGroups ?? [];
      
              const matchedSupremeGroups = allGroups.filter((group) =>
                supremeGroupIds?.includes(group.id ?? -1)
              );
      
              contestant.supremeGroups = matchedSupremeGroups;
      
              console.log(
                `✅ Recalculated contestant ${contestant.contestantUser?.firstName || ''} (ID: ${contestant.id})`
              );
            } else {
              console.warn(`⚠️ Could not find local contestant with ID ${pageantRegistrationId} to update.`);
            }
      
            return response.data;
          } else {
            console.error(`❌ Recalculation API call failed for registration ID ${pageantRegistrationId}`, response);
            alert(`Failed to recalculate age group for registration ID ${pageantRegistrationId}.`);
            return null;
          }
        } catch (error) {
          console.error(`❌ Exception while recalculating age/supreme group for registration ID ${pageantRegistrationId}`, error);
          alert(`An error occurred during reassignment for contestant ID ${pageantRegistrationId}. Check console for details.`);
          return null;
        }
      }
      



    async savePageantRegistration(model: PageantRegistrationRequest): Promise<boolean> {
        try {
            if (model.contestantUserModel) {
                model.contestantUserModel.registeredPageantContestants = undefined;
            }

            const pageantRegistrationResult = model.pageantRegistrationModel?.id && model.pageantRegistrationModel?.id > 0
                ? await this.PageantRegistration.patchPageantRegistration(model)
                : await this.PageantRegistration.addPageantRegistration(model);

            const responseData = pageantRegistrationResult.data.data;
            return responseData !== null;
        }
        catch (error) {
            console.error("Error while saving pageant registration:", error);
            throw new Error("Failed to save pageant registration. Please try again.");
        }
    }




    async saveAgeGroup(
        pageantRegistrationId: number,
        pageantId: number,
        birthday: Date,
        takenFallback: boolean,
        genderId: number,
        moveUpAgeGroup: boolean
    ): Promise<boolean> {
        try {
            // Construct the payload
            const payload = {
                pageantRegistrationId,
                pageantId,
                birthday: birthday.toISOString(), // Ensure date is in ISO format
                takenFallback,
                genderId,
                moveUpAgeGroup,
            };

            // Call the API method
            const response = await this.PageantRegistration.saveAgeGroup(payload);

            // Validate response
            if (!response || !response.data) {
                throw new Error("No response or invalid response structure from the API.");
            }

            console.log(`Age group saved successfully for registration ID: ${pageantRegistrationId}`);
            return response.data.isSuccessful || false;
        } catch (error) {
            console.error("Error saving age group:", error);
            throw new Error(
                `Failed to save age group for registration ID: ${pageantRegistrationId}. Please try again.`
            );
        }
    }





    async updateRegistrationFields(pageantRegistrationId: number, fieldsToUpdate: Record<string, unknown>): Promise<boolean> {
        try {
            // Validate the pageant registration ID
            if (!Number.isInteger(pageantRegistrationId) || pageantRegistrationId <= 0) {
                throw new Error("Invalid pageant registration ID. It must be a positive integer.");
            }

            // Validate the fields to update
            if (!fieldsToUpdate || Object.keys(fieldsToUpdate).length === 0) {
                throw new Error("No fields provided to update. Ensure the payload contains valid fields.");
            }

            // Construct the payload
            const payload = {
                pageantRegistrationId,
                fieldsToUpdate,
            };

            // Call the API method from PageantRegistration
            const response = await this.PageantRegistration.updateRegistrationFields(payload);

            // Validate response
            if (!response || !response.data) {
                throw new Error("No response or invalid response structure from the API.");
            }

            // Return success status from the response
            return response.data.isSuccessful || false;
        } catch (error) {
            console.error("Error while updating registration fields:", error);
            throw new Error(
                `Failed to update registration fields for ID: ${pageantRegistrationId}. Please check the input and try again.`
            );
        }
    }



    async savePageantRegistrationResultsVisibility(pageantRegistrationId: number, isResultsPrivate: boolean): Promise<boolean> {
        try {
            // Check if the pageantRegistrationId is valid
            if (!pageantRegistrationId || pageantRegistrationId <= 0) {
                throw new Error("Invalid pageant registration ID.");
            }

            // Check if isResultsPrivate is a boolean
            if (typeof isResultsPrivate !== 'boolean') {
                throw new Error("Invalid value for isResultsPrivate.");
            }

            // Call the API method to save results visibility
            const response = await this.PageantRegistration.patchPageantRegistrationResultsVisibility({ pageantRegistrationId, isResultsPrivate });

            // Check the response and return a boolean based on success
            return response && response.data !== null;
        } catch (error) {
            console.error("Error while saving pageant registration:", error);
            throw new Error("Failed to save pageant registration. Please try again.");
        }
    }


    async savePageantRegistrationHeadShot(pageantRegistrationId: number, headShot: PictureModel): Promise<boolean> {
        try {
            // Check if the pageantRegistrationId is valid
            if (!pageantRegistrationId || pageantRegistrationId <= 0) {
                throw new Error("Invalid pageant registration ID.");
            }

            // Check if headShot is a valid PictureModel (optional, depending on your validation requirements)
            if (!headShot || typeof headShot !== 'object' || !headShot.image) {
                throw new Error("Invalid headShot object.");
            }

            // Call the API method to save headshot
            const response = await this.PageantRegistration.patchPageantRegistrationHeadShot(
                headShot,
                { pageantRegistrationId }
            );

            // Check the response and return a boolean based on success
            return response && response.data !== null;
        } catch (error) {
            console.error("Error while saving pageant registration:", error);
            throw new Error("Failed to save pageant registration. Please try again.");
        }
    }

    async deletePageantRegistration(id: number): Promise<boolean> {
        try {
            var pageantRegistrationResult = await this.PageantRegistration.deletePageantRegistration(id);
            if (pageantRegistrationResult.data.data) {
                return true;
            }
            return false;
        }
        catch (error) {
            console.log("Error: " + JSON.stringify(error));
            return false;
        }
    }

    // Simplified method to load scores for a contestant
    async loadScores(registeredPageantContestantId: number): Promise<void> {
        try {
            // Directly calling the service and assuming it returns an array of scores
            const scores = await this.ReceivedScoreService.getByContestantGetScoresByContestantIdDetail(registeredPageantContestantId);

            if (Array.isArray(scores) && scores.length > 0) {
                this.ReceivedScore = scores; // Assign the scores to your store
            } else {
                console.warn('No scores found for this contestant.');
            }
        } catch (error) {
            console.error('Error loading scores:', error);
        }
    }

    // Method to save scores for a pageant
    async saveScores(pageantId: number, scores: ReceivedScoreBaseModel[]): Promise<boolean> {
        try {
            // Iterate through each score and save it individually
            for (const score of scores) {
                // Wrap the score in an array and call the saveScoreCreate method
                const result = await this.ReceivedScoreService.saveScoreCreate([score]);
                if (!result) {
                    console.warn('Failed to save score for:', score);
                    return false; // Exit early if any score fails to save
                }
            }

            // If all scores saved successfully, reload the scores for the first contestant
            if (scores.length > 0 && scores[0].registeredPageantContestantId) {
                console.log('Scores saved successfully.');
                await this.loadScores(scores[0].registeredPageantContestantId);
            } else {
                console.warn('No contestant ID available to reload scores.');
            }

            return true; // All scores saved successfully
        } catch (error) {
            console.error('Error saving scores:', error);
            return false;
        }
    }

    // In PageantRegistrationStore
    async bulkSaveScores(pageantId: number, scores: ReceivedScoreBaseModel[]): Promise<boolean> {
        try {
            // Call your controller method that saves the scores
            const result = await this.ReceivedScoreService.bulkSaveBulkSaveScoresForPageantIdCreate(pageantId, scores);
            return result ? true : false;
        } catch (error) {
            console.error('Error in bulk saving scores:', error);
            return false;
        }
    }


       async softDeleteScore(scoreId: number): Promise<boolean> {
        try {
            // Call your controller method that saves the scores
            const result = await this.ReceivedScoreService.softDeleteDelete(scoreId);
            return result ? true : false;
        } catch (error) {
            console.error('Error in deleting score:', error);
            return false;
        }
    }

  async hardSecureDeleteScore(scoreId: number): Promise<boolean> {
        try {
            // Call your controller method that saves the scores
            const result = await this.ReceivedScoreService.hardSecureDeleteDelete(scoreId);
            return result ? true : false;
        } catch (error) {
            console.error('Error in deleting score:', error);
            return false;
        }
    }


      async hardDeleteScore(scoreId: number): Promise<boolean> {
        try {
            // Call your controller method that saves the scores
            const result = await this.ReceivedScoreService.hardDeleteDelete(scoreId);
            return result ? true : false;
        } catch (error) {
            console.error('Error in deleting score:', error);
            return false;
        }
    }


    // Inside PageantRegistrationStore
    // Inside PageantRegistrationStore
    // async getScoresForContestant(registeredContestantId: number): Promise<ReceivedScoreBaseModel[]> {
    //     try {
    //         // Call the service method to fetch scores
    //         const response = await this.ReceivedScoreService.getByContestantDetail(registeredContestantId);

    //         // Safeguard against unexpected formats
    //         if (!Array.isArray(response)) {
    //             console.error('Unexpected response format:', response);
    //             return [];
    //         }

    //         // Return the fetched scores
    //         return response;
    //     } catch (error) {
    //         console.error('Error fetching scores:', error);
    //         return []; // Return an empty array in case of error
    //     }
    // }

    // Let's assume you have a generated or custom API client for calling the back-end method
    async getByContestantDetail(registeredContestantId: number): Promise<ReceivedScoreBaseModel[]> {
        try {
            // Assuming this calls the backend API and returns a response object
            const response = await this.ReceivedScoreService.getByContestantGetScoresByContestantIdDetail(registeredContestantId);

            // Check if the response is successful
            if (!response.ok) {
                throw new Error(`Error fetching scores: ${response.statusText}`);
            }

            // Parse the response body as JSON
            const data = await response.json();

            // Return the data if it's an array, otherwise return an empty array
            return Array.isArray(data) ? data : [];
        } catch (error) {
            console.error("Error fetching scores from API:", error);
            return [];  // Return an empty array on error
        }
    }


    //==============================FETCHING SCORES===========================
    async fetchScores(registeredContestantId: number) { //WORKS to fetching all scores for 1 contestant
        try {
            // Call the service method to fetch scores from the back-end API
            const scores = await this.getByContestantDetail(registeredContestantId);

            // Log the scores to confirm
            console.log('Scores received in component/store for:', registeredContestantId, scores);

            // Do something with the scores, e.g., save them in the state or pass them to a component
            return scores;
        } catch (error) {
            console.error('Error in fetching scores:', error);
            return [];
        }
    }


    // async fetchAllScoresForPageant(pageantId: number): Promise<{ data: ReceivedScoreBaseModel[] }> { // ✅ Explicit return type
    //     try {
    //         console.log(`Fetching all received scores for Pageant ID: ${pageantId}`);
    
    //         // ✅ Call API
    //         const response = await this.ReceivedScoreService.getAllScoresForPageant(pageantId);
    
    //         // ✅ Validate response before using it
    //         if (response?.data && Array.isArray(response.data)) {
    //             console.log("✅ Scores fetched successfully:", response.data);
    //             this.AllReceivedScores = response.data;  // ✅ Save scores to store
    //             return { data: response.data }; // ✅ Return the data
    //         } else {
    //             console.warn("⚠ No valid scores received.");
    //             this.AllReceivedScores = {};
    //             return { data: [] }; // ✅ Return empty array if no valid scores
    //         }
    //     } catch (error) {
    //         console.error("❌ Error fetching all scores:", error);
    //         this.AllReceivedScores = {};  // Reset on error
    //         return { data: [] }; // ✅ Return empty array on error
    //     }
    // }
    





    async getTotalScoresWithDropsForContestantAsyncAll(registeredContestantId: number): Promise<{ [key: string]: any }> {
        try {
            // Use optional chaining to safely access the method
            const scores = await this.ReceivedScoreService?.getTotalScoresWithDropsForContestantByAocAllGetTotalScoresWithDropsForContestantByAocAllDetail(registeredContestantId);

            // Handle case if the service or response is undefined
            if (!scores) {
                console.error('No scores returned from the service');
                return {}; // Return an empty object if no scores
            }

            console.log('Total scores received:', scores);
            return scores; // Return the fetched scores
        } catch (error) {
            console.error('Error fetching total scores:', error);
            return {}; // Return an empty object in case of error
        }
    }


async bulkUpdateContestantSelections(
  request: BulkContestantSelectionUpdateRequestDTO
): Promise<boolean> {
  try {
    if (!request.pageantId || request.pageantId <= 0) {
      throw new Error("Invalid pageantId.");
    }

    if (
      !request.contestantSelectionUpdates ||
      request.contestantSelectionUpdates.length === 0
    ) {
      return true;
    }

    const response =
      await this.PageantRegistration.bulkUpdateContestantSelections(request);

    return response?.data?.data === true || response?.data?.isSuccessful === true;
  } catch (error) {
    console.error("Error bulk updating contestant selections:", error);
    return false;
  }
}

    // async getTotalScoresWithDropsForContestantAsyncAll(registeredContestantId: number): Promise<{ [key: string]: any }> {
    //     try {
    //         // Use optional chaining to safely access the method
    //         const scores = await this.ReceivedScoreService?.getTotalScoresWithDropsForContestantByAocAllDetail(registeredContestantId);

    //         // Handle case if the service or response is undefined
    //         if (!scores) {
    //             console.error('No scores returned from the service');
    //             return {}; // Return an empty object if no scores
    //         }

    //         console.log('Total scores received:', scores);
    //         return scores; // Return the fetched scores
    //     } catch (error) {
    //         console.error('Error fetching total scores:', error);
    //         return {}; // Return an empty object in case of error
    //     }
    // }


    async showRegistrationForm() {
        this.ShowRegistrationForm = true;
    }

    async hideRegistrationForm() {
        this.ShowRegistrationForm = false;
    }

    async setAllowEdit(allowEdit: boolean) {
        this.AllowEdit = allowEdit;
    }

    async getRegistration(id): Promise<RegisteredPageantContestantModel | undefined> {
        try {
            var registrationResult = await this.PageantRegistration.getPageantRegistrationById(id);
            return registrationResult?.data?.data;
        }
        catch (error) {
            console.log("Errror: " + JSON.stringify(error))
        }
    }


    async refreshCurrentRegistration() {
        if (this.CurrentPageantRegistration.id) {
            var result = await this.getRegistration(this.CurrentPageantRegistration.id);
            if (result) {
                this.CurrentPageantRegistration = result;
            }
        }
    }

}

let pageantRegistrationStore: PageantRegistrationStore;

export function GetPageantRegistrationStore(): PageantRegistrationStore {
    if (!pageantRegistrationStore) {
        pageantRegistrationStore = new PageantRegistrationStore({}, false);
    }
    return pageantRegistrationStore;
}